// Portuguese

const lang = {
  gateMediaPreviewHeader: 'Talvez você gostas tambén',
  loadmore: 'Mostra mais',
  nextMedia: 'Média seguinte',
  previousMedia: 'Média anterior',
  closePost: 'Fechar publicação',
  nextPost: 'Publicação seguinte',
  previousPost: 'Publicação anterior',
  outOfStock: 'Fora de estoque',
  numberOfReviews(n) {
    return n === 1 ? 'avaliação' : 'avaliações'
  },
  reportFormField: 'Por favor, introduza uma mensagem',
  reportPost: 'Publicação de relatório',
  reportFormTitle: 'Deseja denunciar esta imagem?',
  reportFormDetails:
    'Se for da opinião que a imagem é inadequada, ilegal ou que infringe os direitos de alguém, é possível denunciar o seu conteúdo. Se denunciar a imagem/texto, os moderadores de conteúdo serão notificados e a ação apropriada irá ser tomada.',
  reportFormMessagePlaceholder: 'Indique o motivo do seu relatório',
  reportFormMessageLabel: 'Mensagem',
  reportFormEmailLabel: 'A sua mensagem de e-mail',
  reportFormSubmitButtonText: 'Enviar relatório',
  reportFormCancelButtonText: 'Cancelar',
  reportFormSentTitle: 'Obrigado pelo seu relatório!',
  reportFormSentCloseButtonText: 'Fechar',
  cardAndTileAriaLabel:
    'Abaixo encontra-se uma lista de publicações de contas em várias redes socias',
  carouselAriaLabel:
    'Abaixo encontra-se um carrossel de publicações de contas em várias redes socias',
  singleAriaLabel: 'Abaixo está uma postagem de uma conta de mídia social',
  poweredBy: 'Desenvolvido por Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date && !userName ? `Foto publicada na ${date}` : ''
    const createdByString = userName && !date ? `Foto por ${userName}` : ''
    const fullString = date && userName ? `Fotografia por ${userName} publicada na ${date}` : ''
    const photo = !date && !userName ? 'Fotografia' : ''
    return `${fullString}${photo}${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Carregue sua mídia',
  openTheGate: 'Abra a caixa de diálogo',
}

// Fotografia do "utilizador" publicada a "data"

export default lang
